import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const purchaseDebitNoteURL = `api/v1/purchase-app/dr-cr-notes`;

//obtaining the paginated data
export const getPurchaseDebitNote = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseDebitNoteURL}/list?note_type=purchase_debit&${paginationQueryParams(
      rowsPerPage,
      search,
      sortOrder,
      pageNo
    )}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPurchaseDebitNote = () => axiosInstance.get(`${purchaseDebitNoteURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePurchaseDebitNote = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${purchaseDebitNoteURL}/list?note_type=purchase_debit&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );

export const getPurchaseDebitNoteAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

// get by id
export const getPurchaseDebitNoteById = (id) => axiosInstance.get(`${purchaseDebitNoteURL}/retrieve/${id}`);

// fetch purchase invoice details
export const getPurchaseDebitNoteDetailsById = (id) =>
  axiosInstance.get(`api/v1/purchase-app/purchase-invoice/retrieve/${id}`);

//creating function
export const createPurchaseDebitNote = (body) => axiosInstance.post(`${purchaseDebitNoteURL}/create`, body);
//updating function
export const updatePurchaseDebitNote = (id, body) => axiosInstance.patch(`${purchaseDebitNoteURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseDebitNoteURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}&note_type=purchase_debit`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
